if ($(window).width() > 1200) {
  function itemSize() {
    var OwlSlideItem = $(".carousel-accordion .accordion_li"),
      // OwlSlideItemmargin = 10,
      itemsLength = 5.6,
      owlFullScrnWidth = $(".carousel-accordion").width(),
      normItemWidth = owlFullScrnWidth / itemsLength - 9;

    OwlSlideItem.stop().animate({ width: normItemWidth + "px" }, 500);
  }
  itemSize();
}

function itemExpanded() {
  var OwlSlidemactive = $(".carousel-accordion .owl-item.active"),
    // OwlSlideItemmargin = $('.carousel-accordion .owl-item').css('marginRight').replace(/[A-Za-z]/g, ""),
    itemsLength = 5,
    owlFullScrnWidth = $(".carousel-accordion").width() - itemsLength,
    normItemWidth = owlFullScrnWidth / itemsLength - 10,
    lgItemWidth = normItemWidth * 2 + 20,
    smItemWidth = (normItemWidth * 3) / 4 - 3;

  OwlSlidemactive.hover(
    function () {
      var $this = $(this);
      $this
        .addClass("expanded")
        .removeClass("active")
        .find(".accordion_li")
        .stop()
        .animate({ width: lgItemWidth + "px" }, 500);
      $(".carousel-accordion .active")
        .find(".accordion_li")
        .stop()
        .animate({ width: smItemWidth + "px" }, 500);
    },
    function () {
      var $this = $(this);
      $this.removeClass("expanded").addClass("active");
      $(".carousel-accordion .active")
        .find(".accordion_li")
        .stop()
        .animate({ width: normItemWidth + "px" }, 500);
    }
  );
}
initialize_owl($(".carousel-accordion"));

function initialize_owl(el) {
  el.owlCarousel({
    loop: false,
    margin: 0,
    navText: ["<i class='angle-left'></i>", "<i class='angle-right'></i>"],
    dots: false,
    autoPlay: false,
    autoplayTimeout: 1000,
    autoplayHoverPause: false,
    nav: false,
    responsiveClass: false,
    responsive: {
      0: {
        items: 1
      },
      460: {
        items: 2
      },
      768: {
        items: 2
      },
      900: {
        items: 3
      },
      1200: {
        margin: 0,
        onInitialized: itemExpanded,
        onRefresh: itemExpanded,
        autoWidth: true,
        mouseDrag: false,
        items: 5
      }
    }
  });
}